import moment from 'moment'

// Helper to get allowed dates (next 2 weeks only)
export const getAllowedDates = () => {
  const today = moment().startOf('day')
  const nextWeekStart = today
    .clone()
    .add(1, 'week')
    .startOf('week')
  const nextWeekEnd = nextWeekStart
    .clone()
    .add(1, 'week')
    .endOf('week')
  const allowed = []
  let d = nextWeekStart.clone()
  while (d.isSameOrBefore(nextWeekEnd)) {
    allowed.push(d.format('YYYY-MM-DD'))
    d.add(1, 'day')
  }
  return {
    allowedDates: allowed,
    startDate: nextWeekStart.format('YYYY-MM-DD'),
    endDate: nextWeekEnd.format('YYYY-MM-DD'),
  }
}

// Helper to get allowed week numbers
export const getAllowedWeekNumbers = () => {
  const today = moment()
  const nextWeekNumber = today
    .clone()
    .add(1, 'week')
    .format('W')
  const weekAfterNextNumber = today
    .clone()
    .add(2, 'week')
    .format('W')
  return [nextWeekNumber, weekAfterNextNumber]
}

export const prepareTableTotals = totals => {
  return [
    [
      {
        label: 'Total Unique Missions:',
        xs: 4,
        align: 'flex-end',
        type: 'label',
      },
      {
        label: totals.morningMissions,
        xs: 2,
        type: 'number',
      },
      {
        label: totals.lunchMissions,
        xs: 2,
        type: 'number',
      },
      {
        label: totals.afternoonMissions,
        xs: 2,
        type: 'number',
      },
      {
        label: totals.totalMissions,
        xs: 1,
        type: 'number',
      },
    ],
    [
      {
        label: 'Percentages:',
        xs: 4,
        align: 'flex-end',
        type: 'label',
      },
      {
        label: totals.morningMissionsPercentage,
        xs: 2,
        type: 'string',
      },
      {
        label: totals.lunchMissionsPercentage,
        xs: 2,
        type: 'string',
      },
      {
        label: totals.afternoonMissionsPercentage,
        xs: 2,
        type: 'string',
      },
      {
        label: '',
        xs: 1,
        type: null,
      },
    ],
  ]
}
